import { PermissaoService } from './../../../_core/services/permissao.service';
import { Arquivo } from 'src/app/_core/models/arquivo';
import { UploadService } from 'src/app/_core/services/upload.service';
import { DatePipe } from '@angular/common';
import { LocalizacaoService } from './../../../_core/services/localizacao.service';
import { TipoDeBemService } from './../../../_core/services/tipo-de-bem.service';
import { CadastroBemService } from './../../../_core/services/cadastro-bem.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { Localizacao } from 'src/app/_core/models/localizacao';
import { TipoDeBem } from 'src/app/_core/models/tipo-de-bem';
import { environment as env } from 'src/environments/environment';
import { Usuario } from 'src/app/_core/models/usuario';

@Component({
  selector: 'app-meus-bens-modal',
  templateUrl: './meus-bens-modal.component.html',
  styleUrls: ['./meus-bens-modal.component.scss']
})
export class MeusBensModalComponent implements OnInit {
  @Input() public nR_BPM_BEM_PATRIMONIAL!: number;
  cadastro: CadastroBem;
  cadastroBens: CadastroBem[];
  form: FormGroup;
  tipoDeBem: TipoDeBem[];
  public localizacao: Localizacao[];
  loading = true;
  listArquivo: Arquivo[];
  isCollapsedFile = true;
  user:Usuario;
  permissao:any;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public datePipe:DatePipe,
    public modalService: NgbModal,
    private cadastroBemService: CadastroBemService,
    private tipoDeBemService: TipoDeBemService,
    private localizacaoService: LocalizacaoService,
    private permissaoService:PermissaoService,
    private uploadService: UploadService) { }

  ngOnInit(): void {
    this.cadastro = new CadastroBem();
    this.listarBensById();
    this.listarTipoDeBensAll();
    this.listarLocalizacaoBensAll();
    this.gerarForm(this.cadastro);
    this.uploadGetById();
    this.loading = false;
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.getAcessoPermissao();
   
  }
  getAcessoPermissao(){
    //console.log/this.user.cD_MATRICULA);
    this.permissaoService.getBy_SiglaMatricula('PATRIMONIO',this.user.cD_MATRICULA).subscribe(
      data =>{
        //console.log/"",data.DS_PERFIL_ACESSO);
        this.permissao = data.indexOf("contabilidade");
      }
    )
  }
  gerarForm(cadastro: CadastroBem) {
    this.form = this.fb.group({
      dS_BPM_ETIQUETA_BEM: [cadastro.dS_BPM_ETIQUETA_BEM, []],
      cD_BPM_NR_UNIDADE: [cadastro.cD_BPM_NR_UNIDADE, []],
      dS_BPM_DESCRICAO_BEM: [cadastro.dS_BPM_DESCRICAO_BEM, []],
      nR_BPM_IMOBILIZADO_TI: [cadastro.nR_BPM_IMOBILIZADO_TI, []],
      nR_BPM_TIPO_BEM_PATRIMONIAL: [cadastro.nR_BPM_TIPO_BEM_PATRIMONIAL, []],
      cD_CDU_MATRICULA_USUARIO_CAUTELA: [cadastro.cD_CDU_MATRICULA_USUARIO_CAUTELA, []],
      vL_BPM_VALOR_AQUISICAO: [cadastro.vL_BPM_VALOR_AQUISICAO, []],
      vL_BPM_DEPRECIACAO_BEM: [cadastro.vL_BPM_DEPRECIACAO_BEM, []],
      dS_BPM_NUMERO_SERIE: [cadastro.dS_BPM_NUMERO_SERIE, []],
      dS_BPM_OUTROS: [cadastro.dS_BPM_OUTROS, []],
      dS_BPM_MARCA: [cadastro.dS_BPM_MARCA, []],
      dS_BPM_MODELO: [cadastro.dS_BPM_MODELO, []],
      dS_BPM_PLACA: [cadastro.dS_BPM_PLACA, []],
      nR_BPM_NUMERO_CONTRATO: [cadastro.nR_BPM_NUMERO_CONTRATO, []],
      dT_BPM_DATA_NOTA_FISCAL: [this.datePipe.transform(cadastro.dT_BPM_DATA_NOTA_FISCAL,'yyyy-MM-dd'), []],
      nR_BPM_NUMERO_NOTA_FISCAL: [cadastro.nR_BPM_NUMERO_NOTA_FISCAL, []],
      dS_BPM_SALA: [cadastro.dS_BPM_SALA, []],
      // dS_BPM_OBSERVACAO: [cadastro.dS_BPM_OBSERVACAO, []],
      fL_BPM_ATIVO: [cadastro.fL_BPM_ATIVO, []],
      fL_BPM_DELETADO: [0],
      arquivos: [cadastro.arquivos]
    })

  }
  listarBensById() {
    if (this.nR_BPM_BEM_PATRIMONIAL != 0) {
      this.cadastroBemService.listarBensById(this.nR_BPM_BEM_PATRIMONIAL)
        .subscribe(
          data => {
            this.cadastro = data;
            this.gerarForm(this.cadastro);
          }

        )
    }
  }
  listarTipoDeBensAll() {
    this.tipoDeBemService.listarTipoDeBensAll()
      .subscribe(
        data => {
          this.tipoDeBem = data;
        }
      )
  }
  listarLocalizacaoBensAll() {
    this.localizacaoService.localizacaoAll()
      .subscribe(
        data => {
          this.localizacao = data;
        }
      )
  }
  uploadGetById() {
    this.uploadService.upload_getById(this.nR_BPM_BEM_PATRIMONIAL)
      .subscribe(
        data => {
          this.listArquivo = data;
        }
      )
  }
  
  upload_abrir(cD_BPM_ARQUIVO_PATRIMONIAL: number) {
    this.uploadService.upload_abrir(cD_BPM_ARQUIVO_PATRIMONIAL)
      .subscribe(
        data => {
          var uri = encodeURIComponent(data)
         window.open(env.baseurl + '/Arquivo/'+this.nR_BPM_BEM_PATRIMONIAL+'/'+cD_BPM_ARQUIVO_PATRIMONIAL)
    })
}
}
